/**
 * Media queries based on screen resize.
 *
 * @see https://developer.mozilla.org/de/docs/Web/API/Window/matchMedia
 * @type {{queryXs: MediaQueryList, queryMd: MediaQueryList}}
 */
const waMediaQueries = {
	queryXs: window.matchMedia('(max-width: 765px)'),
	queryMd: window.matchMedia('(max-width: 1377px)'),
};
